import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronRightIcon, PlayIcon, YouTubeIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {PERSONALIZED_HOMEPAGE_MISSION_THUMBNAIL} from "../../constants/personalized_homepage_mocks";

const CHANNEL_CTA_LABEL = "ZOBACZ NASZ KANAŁ NA YT";

interface IProps {
    videoHref: string;
    channelHref: string;
    onVideoClick?: (videoHref: string) => void;
    onChannelClick?: (ctaLabel: string) => void;
}

export const PersonalizedHomepageMissionCard = (props: IProps) => {
    const {videoHref, channelHref, onVideoClick, onChannelClick} = props;
    const headingId = useId();

    return (
        <section className={cardStyle} aria-labelledby={headingId}>
            <a
                className={thumbStyle}
                href={videoHref}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Obejrzyj odcinek Misji Mieszkanie na YouTube"
                onClick={() => onVideoClick?.(videoHref)}
            >
                <img className={thumbImageStyle} src={PERSONALIZED_HOMEPAGE_MISSION_THUMBNAIL} alt="" loading="lazy" />

                <span className={playStyle}>
                    <PlayIcon size="2.2" fill="var(--colors-white)" />
                </span>

                <span className={chipStyle}>
                    <YouTubeIcon size="1.5" fill="var(--colors-white)" />
                    <Text as="span" variant="info_txt_3">
                        Misja Mieszkanie
                    </Text>
                </span>
            </a>

            <div className={bodyStyle}>
                <div className={copyStyle}>
                    <p className={channelStyle}>
                        <span className={channelDotStyle} aria-hidden="true" />
                        <Text as="span" variant="info_txt_3">
                            NASZ KANAŁ NA YOUTUBE
                        </Text>
                    </p>

                    <Text id={headingId} as="h2" variant="headline_6" className={headingStyle}>
                        Misja Mieszkanie
                    </Text>

                    <Text as="p" variant="body_copy_2" className={descriptionStyle}>
                        Poradniki i historie kupujących pierwsze mieszkanie — jak wybrać, sfinansować i nie przepłacić.
                    </Text>
                </div>

                <Button
                    variant="none_secondary"
                    size="medium"
                    fullWidth
                    href={channelHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    iconRight={ChevronRightIcon}
                    onClick={() => onChannelClick?.(CHANNEL_CTA_LABEL)}
                >
                    {CHANNEL_CTA_LABEL}
                </Button>
            </div>
        </section>
    );
};

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    overflow: "hidden"
});

const thumbStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "20rem",
    overflow: "hidden",

    md: {
        height: "23.2rem"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-primary)",
        outlineOffset: "-2px"
    }
});

const thumbImageStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    maxWidth: "none",
    objectFit: "cover"
});

const playStyle = css({
    position: "relative",
    display: "flex",
    width: "5.6rem",
    height: "5.6rem",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 0, 51, 0.95)",
    borderRadius: "50%",
    boxShadow: "0 8px 24px -6px rgba(0, 0, 0, 0.5)"
});

const chipStyle = css({
    position: "absolute",
    top: "1.2rem",
    left: "1.2rem",
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 1,
    py: 0.5,
    color: "var(--colors-white)",
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    borderRadius: "999px"
});

const bodyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: 2,

    md: {
        padding: 2.5
    }
});

const copyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const channelStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    margin: 0,
    color: "#ff0033"
});

const channelDotStyle = css({
    width: "0.6rem",
    height: "0.6rem",
    backgroundColor: "#ff0033",
    borderRadius: "50%"
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const descriptionStyle = css({
    margin: 0,
    color: "var(--colors-gray-700)"
});
import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronRightIcon, PlayIcon, YouTubeIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {PERSONALIZED_HOMEPAGE_MISSION_THUMBNAIL} from "../../constants/personalized_homepage_mocks";

const CHANNEL_CTA_LABEL = "ZOBACZ NASZ KANAŁ NA YT";

interface IProps {
    videoHref: string;
    channelHref: string;
    onVideoClick?: (videoHref: string) => void;
    onChannelClick?: (ctaLabel: string) => void;
}

export const PersonalizedHomepageMissionCard = (props: IProps) => {
    const {videoHref, channelHref, onVideoClick, onChannelClick} = props;
    const headingId = useId();

    return (
        <section className={cardStyle} aria-labelledby={headingId}>
            <a
                className={thumbStyle}
                href={videoHref}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Obejrzyj odcinek Misji Mieszkanie na YouTube"
                onClick={() => onVideoClick?.(videoHref)}
            >
                <img className={thumbImageStyle} src={PERSONALIZED_HOMEPAGE_MISSION_THUMBNAIL} alt="" loading="lazy" />

                <span className={playStyle}>
                    <PlayIcon size="2.2" fill="var(--colors-white)" />
                </span>

                <span className={chipStyle}>
                    <YouTubeIcon size="1.5" fill="var(--colors-white)" />
                    <Text as="span" variant="info_txt_3">
                        Misja Mieszkanie
                    </Text>
                </span>
            </a>

            <div className={bodyStyle}>
                <div className={copyStyle}>
                    <p className={channelStyle}>
                        <span className={channelDotStyle} aria-hidden="true" />
                        <Text as="span" variant="info_txt_3">
                            NASZ KANAŁ NA YOUTUBE
                        </Text>
                    </p>

                    <Text id={headingId} as="h2" variant="headline_6" className={headingStyle}>
                        Misja Mieszkanie
                    </Text>

                    <Text as="p" variant="body_copy_2" className={descriptionStyle}>
                        Poradniki i historie kupujących pierwsze mieszkanie — jak wybrać, sfinansować i nie przepłacić.
                    </Text>
                </div>

                <Button
                    variant="none_secondary"
                    size="medium"
                    fullWidth
                    href={channelHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    iconRight={ChevronRightIcon}
                    onClick={() => onChannelClick?.(CHANNEL_CTA_LABEL)}
                >
                    {CHANNEL_CTA_LABEL}
                </Button>
            </div>
        </section>
    );
};

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    overflow: "hidden"
});

const thumbStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "20rem",
    overflow: "hidden",

    md: {
        height: "23.2rem"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-primary)",
        outlineOffset: "-2px"
    }
});

const thumbImageStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    maxWidth: "none",
    objectFit: "cover"
});

const playStyle = css({
    position: "relative",
    display: "flex",
    width: "5.6rem",
    height: "5.6rem",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 0, 51, 0.95)",
    borderRadius: "50%",
    boxShadow: "0 8px 24px -6px rgba(0, 0, 0, 0.5)"
});

const chipStyle = css({
    position: "absolute",
    top: "1.2rem",
    left: "1.2rem",
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 1,
    py: 0.5,
    color: "var(--colors-white)",
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    borderRadius: "999px"
});

const bodyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: 2,

    md: {
        padding: 2.5
    }
});

const copyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const channelStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    margin: 0,
    color: "#ff0033"
});

const channelDotStyle = css({
    width: "0.6rem",
    height: "0.6rem",
    backgroundColor: "#ff0033",
    borderRadius: "50%"
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const descriptionStyle = css({
    margin: 0,
    color: "var(--colors-gray-700)"
});
